import { useState } from 'react';
import useAuthenticatedApi from '../../../Authentication/components/hooks/useAuthenticatedApi';

export default function useActivationOrgReassignment() {
    const authenticatedApi = useAuthenticatedApi();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const reassignActivationOrg = async (
        activationId: number,
        newOrgId: number,
    ): Promise<{ success: boolean; message: string } | null> => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await authenticatedApi.post(
                `/activations/${activationId}/reassign-org`,
                { newOrgId },
            );
            return response.data;
        } catch (err: any) {
            console.error('Error reassigning activation org:', err);
            const errorMessage =
                err.response?.data?.message ||
                'Failed to reassign activation organization';
            setError(errorMessage);
            return { success: false, message: errorMessage };
        } finally {
            setIsLoading(false);
        }
    };

    return {
        reassignActivationOrg,
        isLoading,
        error,
    };
}
